import React from "react";
import { isMobile } from "react-device-detect";
import PAGE_COUNTER from "./page-counter/PageCounter.component";

import PageControlsStyles from "./PageControls.styles";
import {
  DefaultPageControlsProps,
  IPageControlsProps,
} from "./PageControls.types";
import SEARCH from "./search/Search.component";

const PAGE_CONTROLS: React.FC<IPageControlsProps> = (
  props: IPageControlsProps
) => {
  return (
    <PageControlsStyles.PageControls
      className="page-controls"
      data-testid="page-controls"
      {...props}
      direction={
        /* istanbul ignore next */ isMobile ? "vertical" : "horizontal"
      }
    >
      <SEARCH />
      <PAGE_COUNTER gap={2} direction="horizontal" />
    </PageControlsStyles.PageControls>
  );
};

PAGE_CONTROLS.defaultProps = DefaultPageControlsProps;
export default PAGE_CONTROLS;
